/**
 * The following key-value pairs describe the maximum physical image dimensions
 * we want to use in our layouts. The key is an arbitrary internal name; the
 * value is a [width, height] array of numbers.

 *
 * The assumed behavior of an image service is to not upsample (upscale) a
 * low-res image. In other words, if we request a larger rendering than what
 * exists, the image service should return the max image size it has.
 *
 * Example: photo.jpg, a 500px x 500px image is uploaded to image service. we
 * request the image as a mediumSquare (1024px square). the image service
 * returns the 500px square image at the mediumSquare URL.s
 */
const IMAGE_DEFINITIONS = {
  base16x9: [80, 45],
  base2x1: [120, 60],
  base3x1: [120, 40],
  base3x2: [120, 80],
  base4x5: [120, 150],
  baseSquare: [120, 120],
  large16x9: [960, 540],
  large2x1: [960, 480],
  large3x1: [972, 324],
  large3x2: [771, 514],
  large3x4: [300, 400],
  large4x5: [800, 1000],
  largePortrait: [400, 500],
  largeSquare: [767, 767],
  medium2x1: [512, 256],
  medium3x1: [513, 171],
  medium3x2: [513, 342],
  medium4x5: [368, 460],
  mediumSquare: [512, 512],
  small2x1: [320, 160],
  small3x2: [312, 208],
  small4x5: [230, 287.5],
  smallSquare: [270, 270]
};

/**
 * Now take the above definitions and expand them into full objects that conform
 * to the "render options" prop type. Right now they just contain width and
 * height, but they eventually get merged with more render-focused image options
 * (imageOps).
 */
const IMAGE_SIZES = (() =>
  Object.entries(IMAGE_DEFINITIONS).reduce(
    (sizes, [size, [width, height]]) =>
      Object.assign({}, sizes, {
        [size]: {
          width,
          height
        }
      }),
    {}
  ))();

export default IMAGE_SIZES;
